"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _inputFormInstructio;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable max-len */
/* eslint-disable quotes, indent */
var _default = (_inputFormInstructio = {
  'inputForm.instruction': 'Alle velden zijn verplicht, tenzij optioneel gemarkeerd',
  'inputField.label.firstName': 'Voornaam',
  'inputField.label.lastName': 'Achternaam',
  'inputField.label.fullName': 'Naam op de kaart',
  'inputField.label.Email': 'E-mail',
  'inputField.label.phoneNumber': 'Telefoonnummer',
  'inputField.placeholder.firstName': 'John',
  'inputField.placeholder.lastName': 'Doe',
  'inputField.placeholder.fullName': 'John Doe',
  'modal.title': 'Weet je zeker dat je wilt verwijderen?',
  'modal.button.disagree': 'Nee',
  'modal.button.agree': 'Ja',
  'inputField.placeholder.email': 'john.doe@cashstar.com',
  'inputField.placeholder.phoneNumber': 'Voer telefoonnummer in',
  'inputField.errorMessage.incompleteField': 'Incompleet veld',
  'inputField.errorMessage.exceedsMaxCharacters': 'Overtreft {max} tekens',
  'inputField.errorMessage.exceedsNameOnCardMaxCharacters': 'Naam op kaart is te lang. Voer {max} tekens of minder in.',
  'inputField.errorMessage.pleaseEnterAValidFirstName': 'Voer een geldige voornaam in',
  'inputField.errorMessage.pleaseEnterAValidLastName': 'Voer een geldige achternaam in',
  'inputField.errorMessage.pleaseEnterAValidFullName': 'Voer een geldige volledige naam in',
  'inputField.errorMessage.invalidAddressValue': 'Voer een geldig adres in',
  'inputField.errorMessage.invalidCityValue': 'Voer een geldige stad in',
  'inputField.errorMessage.invalidName': 'Voer een geldige naam in',
  'header.text.billingInfo': 'Factuurgegevens',
  'submitButton.adyen.label': 'Betaal nu',
  'inputField.label.cardNumber': 'Kaartnummer',
  'inputField.label.cardExpiry': 'Vervaldatum (MM/JJ)',
  'inputField.label.cardCVV': 'CVV/CVC',
  'inputField.placeholder.cardNumber': 'Kaartnummer',
  'inputField.placeholder.cardExpiry': 'MM/JJ',
  'inputField.placeholder.cardCVV': '3 of 4 cijfers',
  'inputField.errorMessage.cardNumberEmpty': 'Voer uw kaartnummer in',
  'inputField.errorMessage.expiryDateEmpty': 'Voer de vervaldatum van uw kaart in',
  'inputField.errorMessage.cardCVVEmpty': 'Voer de kaart CVV/CVC in',
  'inputField.errorMessage.zipCodeEmpty': 'Voer uw postcode van uw factuuradres in',
  'inputField.errorMessage.addressLineOneEmpty': 'Voer de eerste regel van uw adres in',
  'inputField.errorMessage.cityEmpty': 'Voer uw stad in',
  'inputField.errorMessage.stateEmpty': 'Selecteer uw staat',
  'inputField.errorMessage.emptyNameOnCard': 'Vul de naam in op de betaalkaart',
  'inputField.errorMessage.invalidCardNumber': 'Ongeldig kaartnummer. Controleer of u deze correct hebt ingevoerd of probeer een andere betaalkaart.',
  'inputField.errorMessage.cardTypeNotSupported': 'Sorry, we accepteren dit kaarttype niet. Probeer een andere betaalkaart.',
  'inputField.errorMessage.emptyFirstName': 'Voer uw voornaam in',
  'inputField.errorMessage.emptyLastName': 'Voer uw achternaam in',
  'inputField.errorMessage.emptyEmail': 'Voer uw e-mailadres in',
  'inputField.errorMessage.emptyPhone': 'Voer uw telefoonnummer in',
  'inputField.errorMessage.pleaseEnterAValidEmailAddress': 'Voer uw e-mailadres in het juiste formaat in, zoals name@example.com',
  'inputField.errorMessage.pleaseEnterAValidPhoneNumber': 'Voer een geldig telefoonnummer in',
  'inputField.errorMessage.invalidCardExpiry': 'Voer een geldige vervaldatum in',
  'inputField.errorMessage.cardExpired': 'De vervaldatum van de kaart moet in de toekomst liggen',
  'inputField.errorMessage.invalidCardCVV': 'Voer een geldige CVV/CVC in',
  'inputField.label.saveCardLabel': 'Opslaan voor later',
  'inputField.label.makeAsDefaultLabel': 'Markeren als standaard',
  'paymentMethod.paypal.login.initial': 'Om de checkout via PayPal te voltooien, logt u in en valideert u de betalingsgegevens',
  'paymentMethod.paypal.login.success': 'U betaalt met PayPal. Ga verder met het indienen van uw bestelling',
  'paymentMethod.zipPay.maxCartAmount': 'De maximale bestelwaarde om Zip te gebruiken is {amount}',
  'paymentMethod.zipPay.minCartAmount': 'De minimale bestelwaarde om Zip te gebruiken is {amount}',
  'inputField.label.country': 'Pays',
  'paymentMethod.zipPay.extraCharges': 'Een extra handelaarsvergoeding tot {amount} kan van toepassing zijn op het totaal van uw bestelling om Zip te gebruiken.',
  'paymentMethod.adyen.label': 'Credit/Debit card and e-banking',
  'paymentMethod.adyen.single.label': 'Creditcard/betaalpas',
  'paymentMethod.PayPal.label': 'PayPal',
  'paymentMethod.zippay.label': 'Zip',
  'paymentMethod.creditCard.label': 'Creditcard/betaalpas',
  'paymentMethod.googlePay.label': 'Google Pay',
  'paymentMethod.applePay.label': 'Apple Pay',
  'paymentMethod.zippay.preview.message': 'Om Zip te gebruiken, moet het bedrag tussen {minAmount} en {maxAmount} liggen',
  'inputField.label.addressLine.de': 'Adres',
  'inputField.label.addressLineTwo.de': 'Adres 2 (optioneel)',
  'inputField.label.state.de': 'Staat',
  'inputField.label.city.de': 'Stad',
  'inputField.label.zipcode.de': 'Postcode',
  'inputField.label.addressLine.ca': 'Adres',
  'inputField.label.addressLineTwo.ca': 'Adres 2 (facultatief)',
  'inputField.label.state.ca': 'Provincie',
  'inputField.label.city.ca': 'Stad',
  'inputField.label.zipcode.ca': 'Postcode',
  'inputField.label.addressLine.gb': 'Adres',
  'inputField.label.addressLineTwo.gb': 'Adres 2 (optioneel)',
  'inputField.label.state.gb': 'Provincie',
  'inputField.label.city.gb': 'Plaats',
  'inputField.label.zipcode.gb': 'Postcode',
  'inputField.label.addressLine.us': 'Adres',
  'inputField.label.addressLineTwo.us': 'Adres 2 (optioneel)',
  'inputField.label.state.us': 'Staat',
  'inputField.label.city.us': 'Stad',
  'inputField.label.zipcode.us': 'Postcode',
  'inputField.label.addressLine.jp': 'Adres',
  'inputField.label.addressLineTwo.jp': 'Adres 2 (facultatief)',
  'inputField.label.state.jp': 'Prefectuur',
  'inputField.label.city.jp': 'Stad',
  'inputField.label.zipcode.jp': 'Postcode',
  'inputField.label.addressLine.nl': 'Adres',
  'inputField.label.addressLineTwo.nl': 'Adres 2 (optioneel)',
  'inputField.label.state.nl': 'Provincie',
  'inputField.label.city.nl': 'Stad',
  'inputField.label.zipcode.nl': 'Postcode',
  'inputField.label.addressLine.mx': 'Adres',
  'inputField.label.addressLineTwo.mx': 'Adres 2 (optioneel)',
  'inputField.label.state.mx': 'Staat',
  'inputField.label.city.mx': 'Stad',
  'inputField.label.zipcode.mx': 'Postcode',
  'inputField.label.addressLine.au': 'Adres',
  'inputField.label.addressLineTwo.au': 'Adres 2 (optioneel)',
  'inputField.label.state.au': 'Staat',
  'inputField.label.city.au': 'Stad',
  'inputField.label.zipcode.au': 'Postcode',
  'inputField.label.addressLine.se': 'Adres',
  'inputField.label.addressLineTwo.se': 'Adres 2 (optioneel)',
  'inputField.label.state.se': 'Staat',
  'inputField.label.city.se': 'Stad',
  'inputField.label.zipcode.se': 'Postcode',
  'inputField.label.addressLine.ie': 'Adres',
  'inputField.label.addressLineTwo.ie': 'Adres 2 (optioneel)',
  'inputField.label.state.ie': 'Staat',
  'inputField.label.city.ie': 'Stad',
  'inputField.label.zipcode.ie': 'Postcode',
  'inputField.label.addressLine.it': 'Adres',
  'inputField.label.addressLineTwo.it': 'Adres 2 (optioneel)',
  'inputField.label.state.it': 'Staat',
  'inputField.label.city.it': 'Stad',
  'inputField.label.zipcode.it': 'Postcode',
  'inputField.errorMessage.stateEmpty.us': 'Selecteer uw staat',
  'inputField.errorMessage.stateEmpty.ca': 'Selecteer uw provincie',
  'inputField.errorMessage.stateEmpty.gb': 'Selecteer uw provincie',
  'inputField.errorMessage.stateEmpty.nl': 'Selecteer uw provincie',
  'inputField.errorMessage.stateEmpty.jp': 'Selecteer uw prefectuur',
  'inputField.errorMessage.stateEmpty.de': 'Selecteer uw staat',
  'inputField.errorMessage.stateEmpty.mx': 'Selecteer uw staat',
  'inputField.errorMessage.stateEmpty.au': 'Selecteer uw staat',
  'inputField.errorMessage.stateEmpty.se': 'Selecteer uw staat',
  'inputField.errorMessage.stateEmpty.it': 'Selecteer uw staat',
  'inputField.errorMessage.stateEmpty.ie': 'Selecteer uw staat',
  'inputField.errorMessage.zipCodeEmpty.jp': 'Voer uw factuuradres postcode in',
  'inputField.errorMessage.zipCodeEmpty.us': 'Voer uw factuuradres postcode in',
  'inputField.errorMessage.zipCodeEmpty.gb': 'Voer uw factuuradres postcode in',
  'inputField.errorMessage.zipCodeEmpty.ca': 'Voer uw factuuradres postcode in',
  'inputField.errorMessage.zipCodeEmpty.de': 'Voer uw factuuradres postcode in',
  'inputField.errorMessage.zipCodeEmpty.nl': 'Voer uw factuuradres postcode in',
  'inputField.errorMessage.zipCodeEmpty.mx': 'Voer uw factuuradres postcode in',
  'inputField.errorMessage.zipCodeEmpty.au': 'Voer uw factuuradres postcode in',
  'inputField.errorMessage.zipCodeEmpty.se': 'Voer uw factuuradres postcode in',
  'inputField.errorMessage.zipCodeEmpty.ie': 'Voer uw factuuradres postcode in',
  'inputField.errorMessage.zipCodeEmpty.it': 'Voer uw factuuradres postcode in',
  'inputField.errorMessage.invalidZipcode.jp': 'Voer een geldige postcode in',
  'inputField.errorMessage.invalidZipcode.us': 'Voer een geldige postcode in',
  'inputField.errorMessage.invalidZipcode.gb': 'Voer een geldige postcode in',
  'inputField.errorMessage.invalidZipcode.ca': 'Voer een geldige postcode in',
  'inputField.errorMessage.invalidZipcode.de': 'Voer een geldige postcode in',
  'inputField.errorMessage.invalidZipcode.nl': 'Voer een geldige postcode in',
  'inputField.errorMessage.invalidZipcode.mx': 'Voer een geldige postcode in',
  'inputField.errorMessage.invalidZipcode.au': 'Voer een geldige postcode in',
  'inputField.errorMessage.invalidZipcode.se': 'Voer een geldige postcode in',
  'inputField.errorMessage.invalidZipcode.ie': 'Voer een geldige postcode in',
  'inputField.errorMessage.invalidZipcode.it': 'Voer een geldige postcode in',
  'inputField.label.addressLine': 'Adres',
  'inputField.label.addressLineTwo': 'Adres 2 (optioneel)',
  'inputField.label.state': 'Provincie',
  'inputField.label.city': 'Stad',
  'inputField.label.zipcode': 'Postcode',
  'inputField.placeholder.addressLine': 'Adres',
  'inputField.placeholder.addressLineTwo': 'Adres 2 (optioneel)',
  'inputField.placeholder.zipCode': 'Postcode',
  'inputField.placeholder.city': 'Stad'
}, _defineProperty(_inputFormInstructio, "inputField.errorMessage.zipCodeEmpty", 'Voer uw factuuradres postcode in'), _defineProperty(_inputFormInstructio, "inputField.errorMessage.addressLineOneEmpty", 'Voer de eerste regel van uw adres in'), _defineProperty(_inputFormInstructio, 'inputField.errorMessage.addressLineTwoEmpty', 'Vul de tweede regel van uw adres in'), _defineProperty(_inputFormInstructio, "inputField.errorMessage.cityEmpty", 'Voer uw stad in'), _defineProperty(_inputFormInstructio, "inputField.errorMessage.stateEmpty", 'Selecteer uw staat'), _defineProperty(_inputFormInstructio, "inputField.errorMessage.incompleteField", 'Incompleet veld'), _defineProperty(_inputFormInstructio, "inputField.errorMessage.invalidAddressValue", 'Voer een geldig adres in'), _defineProperty(_inputFormInstructio, "inputField.errorMessage.invalidCityValue", 'Voer een geldige stad in'), _defineProperty(_inputFormInstructio, 'inputField.errorMessage.invalidZipcode', 'Voer een geldige postcode in'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state', '- Selecteer staat -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.us', '- Selecteer staat -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.de', '- Selecteer staat -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.mx', '- Selecteer staat -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.af', '- Selecteer staat -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.br', '- Selecteer staat -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.at', '- Selecteer staat -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.es', '- Selecteer staat -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.fr', '- Selecteer staat -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.nl', '- Selecteer de provincie -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.ca', '- Selecteer de provincie -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.gb', '- Selecteer het district -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.jp', '- Selecteer prefectuur -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.au', '- Selecteer staat -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.se', '- Selecteer staat -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.it', '- Selecteer staat -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.ie', '- Selecteer staat -'), _inputFormInstructio);
exports.default = _default;